import { defineNuxtPlugin, useRuntimeConfig } from '#app'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  const params = {
    apiKey: config.public.GOOGLE_MAPS_API_KEY,
    loaded: false,
    libraries: ['drawing', 'places'],
  }

  return {
    provide: {
      GMaps: params,
    },
  }
})
